import {
  CREATE_MODEL,
  GET_MODEL_BY_ID,
  GET_MODEL_BY_URL,
  DELETE_MODEL,
  UPLOAD_MODEL,
} from "./apiEndpoints";

export const fetchModelById = async (modelId) => {
  const response = await fetch(GET_MODEL_BY_ID(modelId));
  if (!response.ok) {
    throw new Error("Failed to fetch the model");
  }
  return response.json();
};

export const fetchModelByUrl = async (modelUrl) => {
  try {
    const response = await fetch(GET_MODEL_BY_URL(modelUrl));

    if (!response.ok) {
      throw new Error(`Failed to fetch model. Status: ${response.status}`);
    }

    return await response.blob();
  } catch (error) {
    console.error("Error in fetchModelByUrl:", error);
    throw error;
  }
};

export const uploadModel = async (restaurantId, file, flatFile) => {
  const formData = new FormData();
  formData.append("modelFile", file);
  formData.append("flatModelFile", flatFile);

  const response = await fetch(UPLOAD_MODEL(restaurantId), {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Failed to upload the model. Status: ${response.status}`);
  }

  return await response.json();
};
